<template>
  <div
    class="tw-block tw-h-full tw-w-full tw-text-left"
    test_id="tips-and-resources-videos"
    :class="[
      wistiaId
        ? `wistia_embed wistia_async_${wistiaId} popover=true popoverAnimateThumbnail=true popoverContent=link`
        : '',
    ]"
    @click="handleVideoClick"
  >
    <div
      class="tw-flex tw-h-full tw-cursor-pointer tw-items-center tw-space-x-3 tw-rounded-xl tw-p-1"
    >
      <PlayIcon class="tw-h-4 tw-w-4 tw-shrink-0" />
      <div class="tw-grow tw-font-semibold">
        {{ title }}
      </div>
    </div>

    <BaseModal
      v-if="youtubeId"
      :name="modalName"
      width-class="tw-max-w-[960px]"
    >
      <div>
        <iframe
          class="tw-aspect-video tw-w-full tw-rounded-xl"
          :src="`https://www.youtube.com/embed/${youtubeId}`"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </BaseModal>
  </div>
</template>

<script setup>
import PlayIcon from '@/assets/images/icons/play.svg'
import { useWistiaScriptLoader } from '@/shared/composables/useWistiaScriptLoader.js'
import { computed, onMounted } from 'vue'
import { useModals } from '@/shared/composables/useModals.js'
import BaseModal from '@/shared/components/BaseModal.vue'

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  wistiaId: {
    type: String,
    default: '',
  },
  youtubeId: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    required: true,
  },
  trackingObject: {
    type: Object,
    required: true,
  },
})

const { openModal } = useModals()
const { loadWistiaVideoScript } = useWistiaScriptLoader()

const modalName = computed(() => {
  return `tips-and-resources-video-${props.id}`
})

const trackClickedVideo = () => {
  if (!Object.keys(props.trackingObject).includes('name')) {
    return new Error('Tracking object must have a name property')
  }
  window.segmentAnalytics.track(props.trackingObject.name, {
    user_type: window.segmentAnalytics.userType(),
    video_title: props.title,
    ...props.trackingObject.props,
  })
}

const handleVideoClick = () => {
  trackClickedVideo()

  if (props.youtubeId) {
    openModal(modalName.value)
  }
}

onMounted(() => {
  if (props.wistiaId) {
    loadWistiaVideoScript(props.wistiaId)
  }
})
</script>

<style>
.wistia_click_to_play {
  width: 100% !important;
  height: 100% !important;
}
</style>
